import { createContext } from 'react';
var CSSPropertiesContext = createContext([]);
export default CSSPropertiesContext;
